import * as _ from "lodash";

import { BarData } from "@ctra/api";

import { ChartContextType } from "../../../../providers";
import { SingleEntityColumnChartProcessor } from "./Individual";
import { MultiEntityColumnChartProcessor } from "./Combined";

export class Processor {
  static create(entities: ChartContextType<BarData>["values"]["entities"]) {
    if (_.size(entities) > 1) {
      return new MultiEntityColumnChartProcessor();
    } else {
      return new SingleEntityColumnChartProcessor();
    }
  }
}
